module.exports = __webpack_public_path__ + "img/api-ctl.d1f816a7.svg";